import React from 'react';
import Logo from '../Img/Logo_projets&finances.png';
import { addSpace, lorem, rescueHtml } from '../components/Tools.js';


const Page4Pilotages = (props) =>
{
    const blue = '#069BD3';
    const greyChapter = '#DBDBDB';
    const height = (props.height*50/950);
    const fontsize = (props.height*12/890);
    const sizelogo = props.width/6;


    return (
        <div style={{width: '100%', height: '100%', padding: 20}}>
            
            {/* Header */}
            <div style={{display: 'flex', height: '20%'}}>
                <div style={{flex: 0.4, display: 'flex', marginLeft: 10}}>
                {props.logo && (
                    <img style={{maxHeight: props.height/8, borderRadius: 5}} src={props.logo} alt="Logo" />
                )}
                </div>

                <div style={{flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{color: blue, fontSize: (fontsize+10)}}>Pilotages</p>
                    <p style={{color: blue, fontSize: (fontsize+6), marginLeft: 5, fontStyle: 'italic'}}>{props.index !== null ? '('+props.index+'/'+props.indexTotal+')' : ''}</p>
                </div>

                <div style={{flex: 0.4, display: 'flex', justifyContent: 'right', marginRight: 25}}>
                    <p style={{color: 'grey', fontSize: (fontsize+4)}}>Synthèse globale des opérations</p>
                </div>
            </div>


            {/* Container */}
            <div style={{flex: 1, height: '60%', fontSize: fontsize}}>
                
                {/* Header */}
                <div style={{flex: 1, display: 'flex', marginRight: 10, marginLeft: 10, justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>
                    <div style={{flex: 0.4, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                        <p>N°inventaire</p>
                    </div>
                    <div style={{width: (props.width/25), justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                        <p>État</p>
                    </div>
                    <div style={{flex: 0.7, alignItems: 'center', display: 'flex'}}>
                        <p style={{marginLeft: 25}}>Intitulé</p>
                    </div>
                    <div style={{flex: 0.4, justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
                        <p>Date de la</p>
                        <p>dernière décision</p>
                    </div>
                    <div style={{flex: 0.9, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                        <p>Décision</p>
                    </div>
                    <div style={{flex: 0.4, justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
                        <p>Date limite</p>
                        <p>de l'action</p>
                    </div>
                    <div style={{flex: 0.9, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                        <p>Action suivante</p>
                    </div>
                </div>

                {props.operations.map((operation, i) => (
                    <div
                        key={i}
                        style={{flex: 1, display: 'flex', margin: (fontsize-2), border: '1px solid '+greyChapter, borderRadius: 5}}
                    >
                        {/* Numéro de l'opération */}
                        <div style={{flex: 0.4, display: 'flex', justifyContent: 'center'}}>
                            <p style={{marginTop: (0 - props.marge), fontSize: (fontsize-2), display: 'flex', alignItems: 'center', height: height, overflow: 'hidden'}}>{operation.numero_inventaire || ''}</p>
                        </div>

                        {/* État / couleur */}
                        <div style={{width: (props.width/25), display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            <div style={{border: '1px solid '+(operation.color || '#999'), backgroundColor: (operation.color || '#999'), borderRadius: '100%', width: "80%", height: "80%"}}></div>
                        </div>

                        {/* Intitulé */}
                        <div style={{flex: 0.7, display: 'flex'}}>
                            <p style={{marginTop: (0 - props.marge), display: 'flex', padding: 5, alignItems: 'center', height: height, overflow: 'hidden', fontWeight: 'bold'}}>{operation.nom || ''}</p>
                        </div>

                        {/* Date de la dernière décision */}
                        <div style={{flex: 0.4, display: 'flex', justifyContent: 'center'}}>
                            <p style={{marginTop: (0 - props.marge), display: 'flex', padding: 5, alignItems: 'center', height: height, overflow: 'hidden'}}>{operation.pilotage_date && operation.pilotage_date !== '0000-00-00'? (operation.pilotage_date.split('-')[2]+'/'+operation.pilotage_date.split('-')[1]+'/'+operation.pilotage_date.split('-')[0]) : ''}</p>
                        </div>

                        {/* Décision */}
                        <div style={{flex: 0.9, display: 'flex', fontSize: (fontsize-3)}}>
                            <p style={{marginTop: (0 - props.marge), display: 'flex', padding: 5, height: height, overflow: 'hidden'}}>{operation.pilotage_decision || ''}</p>
                        </div>

                        {/* Date limite de l'action */}
                        <div style={{flex: 0.4, display: 'flex'}}>
                            <p style={{marginTop: (0 - props.marge), flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 5, height: height, overflow: 'hidden'}}>{operation.pilotage_date_limite && operation.pilotage_date_limite !== '0000-00-00'?(operation.pilotage_date_limite.split('-')[2]+'/'+operation.pilotage_date_limite.split('-')[1]+'/'+operation.pilotage_date_limite.split('-')[0]):''}</p>
                        </div>

                        {/* Action suivante */}
                        <div style={{flex: 0.9, display: 'flex', fontSize: (fontsize-3)}}>
                            <p style={{marginTop: (0 - props.marge), flex: 1, display: 'flex', padding: 5, height: height, overflow: 'hidden'}}>{operation.pilotage_action_suivante || ''}</p>
                        </div>

                    </div>
                ))}
            </div>
            
                        
            {/* Footer */}
            <div style={{display: 'flex', height: '20%', position: 'relative'}}>
                <div style={{position: 'absolute', bottom: 0, display: 'flex', marginLeft: 25, alignItems: 'center', width: 200}}>
                    <p style={{fontSize: (fontsize-2)}}>{props.date}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, left: '47%', display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{fontSize: fontsize}}>page : {props.pagination} / {props.countPageTotal}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, right: 0, display: 'flex', marginRight: 25, alignItems: 'center'}}>
                    <img style={{width: sizelogo}} src={Logo} />
                </div>
            </div>
            
        </div>
    );
}
  
  export default Page4Pilotages;
